import type { Question } from '@api/instant_survey/types';
import { Announcement, HelpV2Icon, InfoFilledIcon, OverlayTriggerTooltip } from '@utilities';

import { getMaxDiffQuestionInfo } from '../../../../../../utilities/helpers';

import styles from './_index.module.scss';

interface MaxDiffAnnouncementProps {
  question: Question;
}

const MaxDiffAnnouncement = ({ question }: MaxDiffAnnouncementProps) => {
  const { numberOfSets, optionsPerSet, questionCost } = getMaxDiffQuestionInfo(question);

  return (
    <Announcement
      className={styles['max-diff-announcement']}
      icon={<InfoFilledIcon />}
      text={
        <>
          <strong>
            This will count as {questionCost} question{questionCost !== 1 ? 's' : ''} for your
            survey.
          </strong>{' '}
          It will be displayed as {numberOfSets} separate questions; each question will show{' '}
          {optionsPerSet} options.
          <OverlayTriggerTooltip
            content={`This is to improve the quality of data and the panelist experience; the time and effort required to answer ${numberOfSets} rotation${
              numberOfSets !== 1 ? 's' : ''
            } is similar to answering a single longer multi-select or open-ended question.`}
          >
            <HelpV2Icon className={styles['max-diff-announcement-help-icon']} />
          </OverlayTriggerTooltip>
        </>
      }
      variant="info"
    />
  );
};

export default MaxDiffAnnouncement;
